import I18N_DOMAINS_CONFIG from "../../../next-i18next-domains.config.json"

// Domains
export const LEGACY_MARKETING_PROJECT_DOMAIN = "marketing.bounce.com"
export const MARKETING_PROJECT_DOMAIN = "bounce.com"
export const I18N_DOMAINS = I18N_DOMAINS_CONFIG.map(domain => domain.domain)

// Base URLs
export const LEGACY_BASE_URL = "https://usebounce.com"
export const LEGACY_I18N_BASE_URL = "https://bounce.com"
